import {
  Home01Icon,
  TiktokIcon,
  InstagramIcon,
  Facebook01Icon,
  TwitterIcon,
  NewTwitterRectangleIcon,
} from "hugeicons-react";

const Socials = () => {
  return (
    <ul className="flex flex-row justify-center items-center md:z-auto z-[-1] md:p-2 p-0  md:my-4 md:mr-16 mr-[250px] ml-6 md:ml-52  md:static rounded-md space-x-2 max-w-[180px] ">
      <li>
        <a
          href="https://www.tiktok.com/@mvuamabet.rdc?is_from_webapp=1&sender_device=pc"
          target="blank"
          className="text-white hover:text-yellow-600 transition duration-300"
        >
          <img src="Tik-tok.svg" alt="tiktok" width={27} color="#000000" />
        </a>
      </li>

      <li>
        <a
          href="https://www.instagram.com/mvuamabetrdc/"
          target="blank"
          className="text-white hover:text-yellow-600 transition duration-300"
        >
          <img src="Ig-icon.png" alt="instagram" width={28} color="#000000" />
        </a>
      </li>

      <li>
        <a
          href="https://www.facebook.com/profile.php?id=61588623248991"
          target="blank"
          className="text-white hover:text-yellow-600   transition duration-300"
        >
          <img src="Fb.svg" alt="facebook" width={28} color="#000000" />
        </a>
      </li>
      {/* <li>
        <a
          href="/"
          target="blank"
          className="text-white hover:text-yellow-600   transition duration-300"
        >
          <img src="icons8-x.svg" alt="x.com" width={30} color="#000000" />
        </a>
      </li> */}
    </ul>
  );
};

export default Socials;
